import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class YugabyteCDCReaderView extends View {
    setup() {
        this.label = "Yugabyte";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.YUGABYTE.id);
        this.model.set("isCDC", true);
    }
}

module.View = YugabyteCDCReaderView;
module.vent = new Backbone.Model();
export default module;
